import React from "react";
import View from "./View";
import { Alert, Button, Container, Stack, Typography } from "@mui/material";
import { getThemeColor } from "colors";
import FileCard from "components/files/FileCard";
import { useDispatch, useSelector } from "react-redux";
import { fonts } from "fonts";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { modalsActions } from "store/react-lib/generic-ui/modals";
import UploadFileModal from "components/files/UploadFileModal";
import Loader from "components/react-lib/generic-ui/Loader";
import { useTheme } from "@emotion/react";
import { useCollection } from "react-firebase-hooks/firestore";
import { collection, orderBy, query, where } from "firebase/firestore";
import { db } from "firebaseApp";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { snapshotToArray } from "utils/react-lib/generic-ui/firebaseUtils";
import Message from "components/chat/Message";
import { COLLECTIONS } from "firebaseCollections";
import Bookmark from "components/bookmarks/Bookmark";

export default function BookmarkedView() {
  const auth = useAuth();
  const theme = useTheme();

  const [bookmarksSnap, loading, error] = useCollection(
    query(
      collection(db, COLLECTIONS.messages),
      where("uid", "==", auth.currentUser.uid),
      where("bookmarked", "==", true),
      orderBy("createdAt", "desc")
    )
  );

  const renderBookmarks = () => {
    if (loading) {
      return <Loader message="Loading bookmarks" />;
    }
    if (error) {
      console.log(error);
      return (
        <Alert severity="error">
          Couldn't load bookmarked messages. Try again later.
        </Alert>
      );
    }
    const messages = snapshotToArray(bookmarksSnap);
    if (messages.length === 0) {
      return (
        <Typography
          fontFamily={fonts.geist}
          textAlign="center"
          sx={{
            color: theme.palette.text.main,
          }}
        >
          No bookmarks.
        </Typography>
      );
    }
    return messages.map((message) => (
      <Message
        key={message.id}
        message={message}
        inContext={false}
        canDelete={false}
        canUseAsPrompt={false}
      />
    ));
  };

  return (
    <View
      renderLeftActions={() => (
        <Typography
          fontFamily={fonts.anton}
          sx={{
            color: theme.palette.text.main,
          }}
        >
          Bookmarks
        </Typography>
      )}
    >
      <UploadFileModal />
      <Container maxWidth="md">
        <Stack
          py={2}
          sx={{
            overflowY: "auto",
            height: "90%",
          }}
        >
          <Stack py={2} spacing={2} alignItems="center" justifyContent="center">
            {renderBookmarks()}
          </Stack>
        </Stack>
      </Container>
    </View>
  );
}
